export class FloorCeilCalculationService {
  /**
   * Get the default floor value from min and max values
   * @param minValue the minimum value
   * @param maxValue the maximum value
   * @returns the default floor value
   */
  static getDefaultFloorVal(minValue: number, maxValue: number): number {
    /* Formula from US ALPVL1B-40 : Min[Entry x Ref] - (Max[Entry x Ref]-Min[Entry x Ref])/ 2 */
    return (minValue !== null && maxValue !== null) ? minValue - ((maxValue - minValue) / 2) : null ;
  }

  /**
   * Get the default ceiling value from min and max values
   * @param minValue the minimum value
   * @param maxValue the maximum value
   * @returns the default ceiling value
   */
  static getDefaultCeilVal(minValue: number, maxValue: number): number {
    /* Formula from US ALPVL1B-40 : Max [Entry x Ref] + (Max[Entry x Ref]-Min[Entry x Ref])/2 */
    return (minValue !== null && maxValue !== null) ? maxValue + ((maxValue - minValue) / 2) : null ;
  }
}